// @flow
import ModalSuccessOld from 'components/Modal/ModalSuccessOld'
import { ResourceSessionsContext } from 'components/ResourceFill/providers/ResourceSessionsProvider'
import { ResourceSharedContext } from 'components/ResourceFill/providers/ResourceSharedProvider'
import * as React from 'react'
import { useHistory } from 'react-router-dom'

function ResourceFillModals(): React.Node {
  const history = useHistory()

  const { isPacket, redirectOnSubmitted, isTablet } =
    React.useContext(ResourceSharedContext) || {}

  const { sessions, sessionId, setSessions } =
    React.useContext(ResourceSessionsContext) || {}

  const currentSession = sessions && sessionId ? sessions[sessionId] : null
  const isSingleResponse = currentSession?.responses?.length === 1

  const getSuccessMessage = React.useCallback(() => {
    if (isPacket) {
      return 'Your packet has been submitted'
    }

    if (isSingleResponse) {
      return 'Your form has been submitted'
    }

    return 'Your form has been submitted'
  }, [isPacket, isSingleResponse])

  const onSuccessPress = React.useCallback(() => {
    if (!currentSession) return
    if (!sessions) return
    if (!setSessions) return

    const { [currentSession.id]: _, ...newFillSessions } = sessions

    setSessions(newFillSessions)
    history.push('/t')
  }, [history, setSessions, currentSession, sessions])

  return (
    <>
      <ModalSuccessOld
        buttonTitle="Go back"
        description={getSuccessMessage()}
        hideButton={!isTablet}
        isVisible={
          !redirectOnSubmitted &&
          Boolean(currentSession?.isSubmitted) &&
          !currentSession?.isInternalForm
        }
        onClose={onSuccessPress}
        title="Thank you!"
      />
    </>
  )
}

export default ResourceFillModals
